import { styled, Tab as MuiTab, TabProps as MuiTabProps } from "@mui/material";

const StyledTab = styled(MuiTab)(({ theme }) => {
  return {
    textTransform: "none",
    textAlign: "center",
    color: theme.palette.text.secondary,
    paddingBottom: "0.25rem",
    // Selected state styling - use primary text color
    "&.Mui-selected": {
      color: theme.palette.text.primary,
      fontWeight: "600",
    },
    // Hover state - use primary text color
    "&:hover": {
      color: theme.palette.text.primary,
      opacity: 0.8,
    },
  };
});

type TabProps = MuiTabProps;

export const TabV2: React.FC<TabProps> = ({ label, ...props }) => {
  return <StyledTab label={label} {...props} />;
};

export default TabV2;
